import { React, useEffect, useState, useRef } from 'react'
import { motion } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import PortalComponents from '../../components/PortalComponents/PortalComponents';
import { Button } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import '../CustomerPortal.css';
import DropFileInputArray from '../../components/DragAndDrop/components/drop-file-input/DropFileInputArray';
import FormComponent from '../../components/FormComponents/FormComponent';
import loading from '../../Images/three-dots.svg'
import DropChange from '../../components/DragAndDrop/components/drop-file-input/DropChange';
const areArraysIdentical = (array1, array2) => {
    // Check if arrays have the same length
    if (array1?.length !== array2?.length) {
      return false;
    }
  
    // Sort both arrays
    const sortedArray1 = array1?.slice().sort();
    const sortedArray2 = array2?.slice().sort();
  
    // Compare each element in the sorted arrays
    for (let i = 0; i < sortedArray1?.length; i++) {
      if (sortedArray1[i] !== sortedArray2[i]) {
        return false;
      }
    }
  
    // If all elements are identical, return true
    return true;
  };


const Nominees = ({ formik, setSelectedService, CheckProofDocRequired, selectedData, CheckPercentageValid, req_count, alerationReq, policy_number, isReqLoading }) => {
    
    useEffect(() => {
        CheckPercentageValid();
        if(selectedData?.nominee && formik.values.nominee){
            setRequestEnable(!areArraysIdentical(selectedData.nominee, formik.values.nominee))
        }
        
       
    }, [formik.values.nominee]);


    console.log(selectedData)
    const [fileList, setFileList] = useState([])
    const[requestEnable,setRequestEnable] = useState(false);
    function RemoveProofDocInInitial(type, index) {

        if (!(selectedData.nominee.length >= index + 1 && selectedData.nominee && selectedData.nominee[index] && formik.values.nominee && formik.values.nominee[index] && selectedData.nominee[index][type] != formik.values.nominee[index][type])) {

            const proof_docs = formik.values.nominee && formik.values.nominee[index] && formik.values.nominee[index].proof_doc;

            if (proof_docs) {
                const hasType = proof_docs.some(item => item.name === type);

                if (hasType) {

                    const filteredProofDocs = proof_docs.filter(item => item.name !== type);


                    formik.setFieldValue(`nominee[${index}].proof_doc`, filteredProofDocs);
                }
            }

        }
    }

    return (
        <>
            <Row className='justify-content-start d-flex' style={{ width: "100%" }}>

                <Col xs={1} className='my-3 justify-content-start d-flex'>
                    <motion.div

                        onClick={() => {
                            setSelectedService(0)
                            formik.setFieldValue('nominee', selectedData.nominee);
                        }}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </motion.div>
                </Col>


            </Row>
            <Row style={{ width: "100%" }} className='d-flex justify-content-center'>
                <h1 style={{fontSize:"20px", fontWeight:"bold" ,textAlign:"center"}}>NOMINEES</h1>
            </Row>
  
            {
                selectedData?.nominee && formik.values ? (
                    formik.values.nominee?.map((value, index) => {

                 
                        return (
                            <Row style={{ width: "100%" ,margin:0 }} key={`nominee_key_${index}`}>
                                <Col xs={12} className='pt-5  mt-5 nominee-con' >
                                    {selectedData.nominee.length < index + 1 ?
                                        <Row className='mb-2'>
                                            <Col xs={12} className='d-flex justify-content-end'>
                                                <Button isIconOnly={true} style={{ scale: "0.5" }}><FontAwesomeIcon icon={faCircleXmark} onClick={(indexToRemove) => {
                                                    const updatedNominees = [...formik.values.nominee];
                                                    updatedNominees.splice(index, 1);
                                                    formik.setFieldValue('nominee', updatedNominees);
                                                    const filterdList = fileList.filter(item => item.index !== index);
                                                    const newFiles = filterdList.map(item => ({
                                                        ...item,
                                                        index: item.index > index ? item.index - 1 : item.index
                                                    }));
                                                    setFileList(newFiles)



                                                }} style={{ height: "100%" }} /></Button>
                                            </Col>
                                        </Row>
                                        :
                                        null
                                    }

                                    <Row>
                                        <Col xs={6}>
                                            <PortalComponents
                                                type={"input-name"}
                                                label={"Full Name"}
                                                name={`nominee[${index}].name`}
                                                value={formik.values.nominee?.[index]?.name}
                                                onchange={formik.handleChange}
                                                formik={formik}
                                                errors={formik.errors.nominee?.[index]?.name}

                                            />
                                            {CheckProofDocRequired("nominee", "name", index)}
                                            {RemoveProofDocInInitial("name", index)}
                                            {selectedData.nominee.length >= index + 1 && selectedData.nominee && selectedData.nominee[index] && formik.values.nominee && formik.values.nominee[index] && selectedData.nominee[index].name != formik.values.nominee[index].name ?

                                                <Col xs={12} className='d-flex justify-content-center'>
                                                    <DropChange fileList={fileList} setFileList={setFileList} values={formik.values} index={index} CheckProofDocRequired={CheckProofDocRequired} setFieldValue={formik.setFieldValue} error={formik.errors.nominee?.proof_doc && formik.errors.nominee?.proof_doc[index]?.name} nameofFile={"name"} table={"nominee"} id={value?.id} />
                                                </Col> :
                                                null
                                            }

                                        </Col>
                                        <Col xs={6}>
                                            <Row>
                                                <Col xs={12}>
                                                    <div className='mt-3'> <FormComponent
                                                        type={"date-picker"}
                                                        label={"Birthday"}
                                                        value={formik.values.nominee?.[index]?.birthday}
                                                        name={`nominee[${index}].birthday`}
                                                        setFieldValue={formik.setFieldValue}
                                                        errors={formik.errors.nominee?.[index]?.birthday}

                                                    /></div>

                                                </Col>
                                                <Col xs={12}>

                                                    {CheckProofDocRequired("nominee", "birthday", index)}
                                                    {RemoveProofDocInInitial("birthday", index)}

                                                    {selectedData.nominee.length >= index + 1 && selectedData.nominee && selectedData.nominee[index] && formik.values.nominee && formik.values.nominee[index] && selectedData.nominee[index].birthday != formik.values.nominee[index].birthday ?

                                                        <Col xs={12} className='d-flex justify-content-center'>


                                                            <DropChange fileList={fileList} id={value?.id}  setFileList={setFileList} values={formik.values} index={index} CheckProofDocRequired={CheckProofDocRequired} setFieldValue={formik.setFieldValue} error={formik.errors.nominee?.proof_doc && formik.errors.nominee?.proof_doc[index]?.birthday} nameofFile={"birthday"} table={"nominee"} />
                                                        </Col> :
                                                        null
                                                    }

                                                </Col>
                                            </Row>


                                        </Col>

                                    </Row>
                                    <Row className='my-0'  >
                                        <Col xs={6}>

                                            <PortalComponents
                                                type={"input-nic"}
                                                label={"NIC"}
                                                name={`nominee[${index}].nic`}
                                                formik={formik}
                                                value={formik.values.nominee?.[index]?.nic}
                                                onchange={formik.handleChange}
                                                errors={formik.errors.nominee?.[index]?.nic}


                                            />
                                            {CheckProofDocRequired("nominee", "nic", index)}
                                            {RemoveProofDocInInitial("nic", index)}

                                            {selectedData.nominee.length >= index + 1 && selectedData.nominee && selectedData.nominee[index] && formik.values.nominee && formik.values.nominee[index] && selectedData.nominee[index].nic != formik.values.nominee[index].nic ?

                                                <Col xs={12} className='d-flex justify-content-center'>


                                                    <DropChange fileList={fileList} id={value?.id}  setFileList={setFileList} values={formik.values} index={index} CheckProofDocRequired={CheckProofDocRequired} setFieldValue={formik.setFieldValue} error={formik.errors.nominee?.proof_doc && formik.errors.nominee?.proof_doc[index]?.nic} nameofFile={"nic"} table={"nominee"} />
                                                </Col> :
                                                null
                                            }
                                        </Col>
                                        <Col xs={6}>
                                            <Row>
                                                <Col xs={12}>
                                                    <PortalComponents
                                                        type={"input-relationship"}
                                                        label={"Relationship"}
                                                        name={`nominee[${index}].relationship`}
                                                        formik={formik}
                                                        value={formik.values.nominee?.[index]?.relationship}
                                                        onchange={formik.handleChange}
                                                        errors={formik.errors.nominee?.[index]?.relationship}


                                                    />

                                                </Col>
                                                <Col xs={12}>

                                                    {CheckProofDocRequired("nominee", "relationship", index)}
                                                    {RemoveProofDocInInitial("relationship", index)}

                                                    {selectedData.nominee.length >= index + 1 && selectedData.nominee && selectedData.nominee[index] && formik.values.nominee && formik.values.nominee[index] && selectedData.nominee[index].relationship != formik.values.nominee[index].relationship ?

                                                        <Col xs={12} className='d-flex justify-content-center'>


                                                            <DropChange fileList={fileList} id={value?.id}  setFileList={setFileList}values={formik.values} index={index} CheckProofDocRequired={CheckProofDocRequired} setFieldValue={formik.setFieldValue} error={formik.errors.nominee?.proof_doc && formik.errors.nominee?.proof_doc[index]?.relationship} nameofFile={"relationship"} table={"nominee"} />
                                                        </Col> :
                                                        null
                                                    }

                                                </Col>
                                            </Row>


                                        </Col>

                                        <Col xs={6} className='d-flex justify-content-center'>

                                        <PortalComponents
                                            type={"input"}
                                            label={"Proof Description - Please describe what you requested.."}
                                            formik={formik}
                                            name={`nominee[${index}].proof_description`}
                                            value={formik.values.nominee?.[index]?.proof_description}
                                            onchange={formik.handleChange}
                                            errors={formik.errors.nominee?.[index]?.proof_description}                                           

                                        />


                                            

                                        </Col>

                        <Col xs={6} className='d-flex justify-content-center'>

                                            <PortalComponents
                                                type={"slider"}
                                                label={"Percentage"}
                                                formik={formik}
                                                name={`nominee[${index}].percentage`}
                                                value={formik.values.nominee?.[index]?.percentage}
                                                onchange={(e) => {

                                                    formik.setFieldValue(`nominee[${index}].percentage`, e[0] || e, false);
                                                    CheckPercentageValid();
                                                    formik.validateForm()
                                                }}

                                                errors={formik.errors.nominee?.[index]?.percentage}
                                            />
                        </Col>
                                        {selectedData.nominee.length < index + 1 ?

                                            <Col xs={12} className='d-flex justify-content-center'>

                                                {CheckProofDocRequired("nominee", "new", index)}

                                                <DropFileInputArray fileList={fileList} setFileList={setFileList} values={formik.values} index={index} CheckProofDocRequired={CheckProofDocRequired} setFieldValue={formik.setFieldValue} error={formik.errors.nominee?.proof_doc && formik.errors.nominee?.proof_doc[index]?.new} nameofFile={"new"} table={"nominee"} />
                                            </Col> :
                                            null
                                        }
                                    </Row>
                                    <Row>

                                    </Row>

                                </Col>





                            </Row>

                        )


                    }

                    )
                ) : (
                    <Row>
                        <img src={loading} className='m-5' style={{ width: "40%" }} />
                    </Row>
                )
            }
            { selectedData?.nominee && formik.values&&formik.values.nominee&&formik.values.nominee.length==0&&
            <div className='no-result-con p-5 d-flex justify-content-center align-items-center my-5'>
                <div className='d-flex flex-row align-items-center'>
                <FontAwesomeIcon icon={ faTimesCircle} style={{scale:"1.5"}}/> <div className='mx-3'>No Nominees  </div>
                </div>

            </div>

            }


            <Row style={{ width: "100%" }} className='d-flex justify-content-end'>
                <Col lg={3} md={3} sm={12} xs={12} className='my-4 d-flex justify-content-end'>
                    <Button
                        onClick={() => formik.setFieldValue('nominee', [...formik.values.nominee, { name: '', nic: '', mobile: '', email: '', proof_doc: [] }])}
                        color='success' variant="solid"
                        style={{ color: "white" }}
                    >
                        Add Nominee
                    </Button>
                </Col>
            </Row>
            {requestEnable&&<Row style={{ width: "100%" }} className='d-flex justify-content-center'>
                <Col lg={3} md={3} sm={12} xs={12} className='my-4 d-flex justify-content-center'>

                    {req_count && req_count > 0 ?
                        <Button
                            onClick={() => { alerationReq("nominee add", "nominee", policy_number) }}
                            color='warning' variant="solid"
                            style={{ color: "white" }}
                            isDisabled
                        >
                            Request Pending
                        </Button> :
                        <Button
                            isLoading={isReqLoading}
                            onClick={() => { alerationReq("nominee add", "nominee", policy_number) }}
                            color='primary' variant="solid"
                            style={{ color: "white" }}
                        >
                            Request Change
                        </Button>
                    }




                </Col>
            </Row>}
        </>
    )
}

export default Nominees
